import React from 'react';
import { generateWhatsAppLink } from '../utils/whatsappUtils';

const WhatsAppReminderButton = ({ patientName, phoneNumber, appointmentTime, clinicName }) => {
  const message = `Hi ${patientName}, this is a reminder for your appointment at ${clinicName || 'our clinic'} today at ${appointmentTime}. See you soon!`;
  const whatsappLink = generateWhatsAppLink(phoneNumber, message);

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '8px 12px',
        backgroundColor: '#25D366',
        color: 'white',
        borderRadius: '6px',
        textDecoration: 'none',
        fontSize: '13px',
        fontWeight: '600'
      }}
    >
      <span style={{ marginRight: '6px' }}>💬</span>
      Send Reminder
    </a>
  );
};

export default WhatsAppReminderButton;
